const PAYMENT_METHODS = {
  BRAINTREE: {
    ID: "braintree",
  },
};

export default PAYMENT_METHODS;
